// angular
//     .module("HeroPRO")
//     .controller("ProjectDetailsWalkthroughController", projectDetailsWalkthroughController);


import _ from 'lodash';

/* @ngInject */
export default function projectDetailsWalkthroughController(FRInformationFactory, FRClosingFactory, FRDocumentsFactory, HPStateMachineConfig, raSpinnerService, WalkthroughFactory) {
    const vm = this;
    vm.stateMachineData = {};
    vm.HPStateMachineConfig = HPStateMachineConfig;

    init();

    vm.isCompletionCertificateRegenerated = function () {
        return FRDocumentsFactory.getCompletionCertificateRegenerated();
    };

    vm.confirmProjectDetails = function () {
        raSpinnerService.show('walkthroughSpinner');
        FRClosingFactory.confirmProjectDetails().then((response) => {
            FRInformationFactory.setStateMachineData(response.data.PipelineStageId, response.data.FundingRequestPipelineStageId, response.data.LoanStateId, response.data.FundingRequestStateId, response.data.CompletionCertificateStateId);
            FRClosingFactory.setProjectDetails(_.omit(response.data, 'FundingRequestId', 'LoanStateId'));
            FRClosingFactory.setProjectDetailsConfirmed();
            WalkthroughFactory.loadWalkthrough();
            raSpinnerService.hide('walkthroughSpinner');
        });
    };

    function init() {
        FRInformationFactory.getFundingRequestInformationPromise().then(() => {
            vm.stateMachineData = FRInformationFactory.getStateMachineData();
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/appDetail/walkthrough/getPaid/projectDetailsWalkthroughController.js